import React, { useState, useRef } from 'react';
import { Fab, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { CreateRounded, Undo } from '@mui/icons-material';

export default function MenuFab( {handleAddTask} ) {

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const pressTimerRef = useRef(null);
  const isLongPressRef = useRef(false);

  const LONG_PRESS_THRESHOLD = 500; 

  const handlePointerDown = (event) => {
    event.preventDefault();
    isLongPressRef.current = false;
    const currentTarget = event.currentTarget;

    // Start a timer. If it completes before pointerUp, it's a long press.
    pressTimerRef.current = setTimeout(() => {
      isLongPressRef.current = true;
      setAnchorEl(currentTarget); // Open the menu
    }, LONG_PRESS_THRESHOLD);
  };

  const handlePointerUp = () => {
    // Clear the timer immediately so the long press doesn't fire late
    if (pressTimerRef.current) {
      clearTimeout(pressTimerRef.current);
    }

    // If the timer didn't finish, treat this as a standard tap/click
    if (!isLongPressRef.current) {
      handleShortTapAction();
    }
  };

  // Prevent default context menus from breaking the experience on mobile
  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  const handleShortTapAction = () => {
    if(handleAddTask) { handleAddTask()};
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Fab
        color="primary"
        aria-label="add"
        onPointerDown={handlePointerDown}
        onPointerUp={handlePointerUp}
        // onClick={handleClick}
        onContextMenu={handleContextMenu}
        sx={{
          position: 'fixed',
          bottom: 75, // Shifts up on mobile to avoid overlapping your AppLayout BottomNav!
          right: 20,
          zIndex: 1050,
          userSelect: 'none',
          WebkitUserSelect: 'none',
        }}
      >
        <AddIcon />
      </Fab>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        // Controls where the popup menu spawns relative to the FAB
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        {/* <MenuItem onClick={handleMenuClose}>
          <ListItemIcon><AddIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Create New</ListItemText>
        </MenuItem> */}
        
        <MenuItem onClick={handleMenuClose}>
          <ListItemIcon><CreateRounded fontSize="small" /></ListItemIcon>
          <ListItemText>Create Task for This Filter</ListItemText>
        </MenuItem>

        <MenuItem onClick={handleMenuClose}>
          <ListItemIcon><Undo fontSize="small" /></ListItemIcon>
          <ListItemText>Undo</ListItemText>
        </MenuItem>

      </Menu>
    </>
  );
}